import React, {useState, useEffect} from 'react'
import {Grid, useMediaQuery, useTheme, IconButton, Box} from "@mui/material";
import {FlexBox, FlexRowCenter} from "components/flex-box";
import LazyImage from "components/LazyImage";
import {getImage, getImageFromURL} from "helpers/utils";
import BazaarAvatar from "components/BazaarAvatar";

const ImageAlbum = ({images, onClickBottomRightIcon, onClickBottomRight,onClickTopRightIcon, onClickTopRight, mainOnly}) => {

    const [selectedImage, setSelectedImage] = useState(0);
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.only('xs'));
    const isSm = useMediaQuery(theme.breakpoints.only('sm'));
    const isMd = useMediaQuery(theme.breakpoints.only('md'));
    
    // Reset to first image when images change
    useEffect(() => {
        setSelectedImage(0);
    }, [images]);
    
    // Determine image size based on screen size
    const getImageSize = () => {
        if (isXs) return { width: 280, height: 280, mockHeight: 280, iconHeightLg: 80, iconHeightSm: 50 };
        if (isSm) return { width: 350, height: 350, mockHeight: 350, iconHeightLg: 90, iconHeightSm: 50 };
        if (isMd) return { width: 400, height: 400, mockHeight: 400, iconHeightLg: 100, iconHeightSm: 70 };
        return { width: 500, height: 500, mockHeight: 500, iconHeightLg: 110, iconHeightSm: 70 }; // lg and xl
    };
    
    const imageSize = getImageSize();

    const handleImageClick = (ind) => () => {
        setSelectedImage(ind);
    };

    const renderImageAlbum = () => (
        <Grid item md={6} xs={12} alignItems="center" display="flex" flexDirection="column" justifyContent="center">
            {!mainOnly &&
                <FlexBox overflow="auto" justifyContent="center" width="100%">
                    {images && images.length > 1 && images.map((url, ind) => (
                        <FlexRowCenter
                            key={ind}
                            width={64}
                            height={64}
                            minWidth={64}
                            bgcolor="white"
                            border="1px solid"
                            borderRadius="10px"
                            ml={ind === 0 ? "auto" : 0}
                            style={{
                                cursor: "pointer",
                            }}
                            onClick={handleImageClick(ind)}
                            mr={ind === images.length - 1 ? "auto" : "10px"}
                            borderColor={
                                selectedImage === ind ? "primary.main" : "grey.400"
                            }
                        >
                            <BazaarAvatar src={getImageFromURL(url)} variant="square" height={40}/>
                        </FlexRowCenter>
                    ))}
                </FlexBox>
            }
            <Box position="relative" display="flex" justifyContent="center" width="100%">
                <LazyImage
                    width={imageSize.width}
                    height={imageSize.height}
                    mockHeight={imageSize.mockHeight}
                    loading="eager"
                    objectFit="contain"
                    src={getImage(images, selectedImage)}
                />
                {onClickBottomRightIcon && onClickBottomRight && (
                    <IconButton
                        onClick={onClickBottomRight}
                        sx={{
                            position: 'absolute',
                            bottom: 16,
                            right: 16,
                            width: imageSize.iconHeightLg,
                            height: imageSize.iconHeightLg,
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                            },
                            zIndex: 2,
                        }}
                    >
                        {onClickBottomRightIcon}
                    </IconButton>
                )}
                {onClickTopRightIcon && onClickTopRight && (
                    <IconButton
                        onClick={onClickTopRight}
                        sx={{
                            position: 'absolute',
                            top: 2,
                            right: 2,
                            width: imageSize.iconHeightSm,
                            height: imageSize.iconHeightSm,
                            color: 'white',
                            '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                            },
                            zIndex: 2,
                        }}
                    >
                        {onClickTopRightIcon}
                    </IconButton>
                )}
            </Box>
        </Grid>
    );

    return (
        <>
            {images && images.length > 0 && renderImageAlbum()}
        </>
    );
}


export default ImageAlbum;
